import React, { useState } from "react";
import { ConfigProvider } from "antd";
import { MarketOverviewTable } from "../../../styles/MarketOverview.styled";
import { CoreBrandsTableProps } from "../types";
import { useSelector } from "react-redux";
import { getCoreBrandsColumns } from "./tableConfigs";

const CoreBrandsTable: React.FC<CoreBrandsTableProps> = ({
  displayCoreBrandsData,
  editingCoreBrandsData,
  isEditingCoreBrands,
  editingCoreBrandsRows,
  brandOptions,
  brandDataLoading,
  // treeSelectStates is reached through getTreeSelectState rather than directly
  handleCoreBrandInputChange,
  handleCoreBrandClearAndCompact,
  updateTreeSelectState,
  getTreeSelectState,
  fetchBrandData,
  getCountryCodeFromMarket,
  getSelectedBrandNames,
  generateCoreBrandData,
  getFilteredBrandOptions,
  findBrandByName,
  mergeCompleteSubbrandsToParent,
  fetchCompetitorsData,
  getCompetitorsTreeData,
  companiesWithBrandsLoading,
}) => {
  const authIdClient = useSelector((state: any) => state.auth.id_client);

  // Cells whose Select is forced open, which is how the "+ Add" button works
  const [openSelectKeys, setOpenSelectKeys] = useState<Set<string>>(new Set());
  const [selectActivatedKeys, setSelectActivatedKeys] = useState<Set<string>>(
    new Set()
  );

  return (
    <div className="p-6 bg-white rounded-3xl shadow-[2px_4px_12px_0px_rgba(0,0,0,0.02)] border border-black/5 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-black/90 text-base font-semibold font-[Inter] leading-8">
          Core brands & Competitor
        </div>
      </div>

      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Inter",
          },
          components: {
            Table: {
              headerBorderRadius: 12,
              cellPaddingBlock: 10,
              cellPaddingInline: 10,
              borderColor: "#e5e7eb",
              headerBg: "#f9fafb",
            },
            Select: {
              borderRadius: 18,
              fontFamily: "Inter",
              fontSize: 12,
            },
            Tree: {
              fontFamily: "Inter",
              fontSize: 12,
              nodeHoverBg: "#f5f5f5",
              nodeSelectedBg: "#e6f4ff",
            },
            TreeSelect: {
              borderRadius: 18,
              fontFamily: "Inter",
              fontSize: 12,
              nodeHoverBg: "#f5f5f5",
            },
          },
        }}
      >
        <MarketOverviewTable
          columns={getCoreBrandsColumns({
            isEditingCoreBrands,
            editingCoreBrandsRows,
            editingCoreBrandsData,
            displayCoreBrandsData,
            openSelectKeys,
            selectActivatedKeys,
            setSelectActivatedKeys,
            setOpenSelectKeys,
            brandOptions,
            brandDataLoading,
            companiesWithBrandsLoading,
            authIdClient,
            handleCoreBrandInputChange,
            handleCoreBrandClearAndCompact,
            updateTreeSelectState,
            getTreeSelectState,
            fetchBrandData,
            getCountryCodeFromMarket,
            getSelectedBrandNames,
            generateCoreBrandData,
            getFilteredBrandOptions,
            findBrandByName,
            mergeCompleteSubbrandsToParent,
            fetchCompetitorsData,
            getCompetitorsTreeData,
          })}
          dataSource={
            displayCoreBrandsData.length > 0 ? displayCoreBrandsData : []
          }
          pagination={false}
          size="small"
          rowClassName="text-center"
          bordered={true}
          scroll={{ x: "max-content" }}
        />
      </ConfigProvider>
    </div>
  );
};

export default CoreBrandsTable;
